import { useSelectorTyped } from "../../../../common/redux/store";
import { stepLabels } from "../../utils/step-labels";
import React, { useRef, useState } from "react";
import { GetStartedPageActions } from "../../redux";
import { TeamType } from "../../../create-team/redux";
import { useDispatch } from "react-redux";

export default function useReviewAndSubmitController() {
  const dispatch = useDispatch();
  const basicInfo = useSelectorTyped((state) => state.getStartedPage.experimentsAndInnovations.basicInfo);
  const infraConfig = useSelectorTyped((state) => state.getStartedPage.experimentsAndInnovations.infraConfig);
  const applicationCreateRequestProgress = useSelectorTyped((state) => state.getStartedPage.createApplication.progress);
  const isAcknowledged = useRef(false);
  const [showError, setShowError] = useState(false);

  const setAcknowledgementError = () => {
    if (isAcknowledged.current) {
      setShowError(false);
    }
    else {
      setShowError(true);
    }
  };

  return {
    basicInfo,
    infraConfig,
    onSubmitBtnClick: () => {
      if (isAcknowledged.current) {
        dispatch(GetStartedPageActions.createApplication({
          application: { basicInfo, infraConfig },
          teamType: TeamType.EXPERIMENT_AND_INNOVATION,
        }));
      }
      setAcknowledgementError();
    },
    isCreateApplicationRequestInProgress: () => applicationCreateRequestProgress !== null,
    getStepLabelsForPage: () => stepLabels,
    onAcknowledgementChanged: (event: React.ChangeEvent<HTMLInputElement>) => {
      isAcknowledged.current = event.target.checked;
      setAcknowledgementError();
    },
    showError,
  };
}
